import { useLoadStylesheet } from '@/components/results-category/components/calendly/hooks/use-load-stylesheet.hook';
import { useLoadScript } from '@/components/results-category/components/calendly/hooks/use-load-script.hook';
import { useCallback } from 'react';
export function useCalendlySchedule() {
    var isLoaded = useLoadScript({
        url: 'https://assets.calendly.com/assets/external/widget.js',
    }).isLoaded;
    var isStylesheetLoaded = useLoadStylesheet({
        url: 'https://assets.calendly.com/assets/external/widget.css',
    }).isLoaded;
    var openCalendlySchedule = useCallback(function () {
        if (!window.Calendly)
            return;
        window.Calendly.initPopupWidget({
            url: 'https://calendly.com/lexiehearing/heardigits_consultation',
        });
    }, []);
    return { openCalendlySchedule: openCalendlySchedule, isLoaded: isLoaded && isStylesheetLoaded };
}
